module.exports = __webpack_public_path__ + "static/media/globe.e3923b6f.svg";